export default __webpack_public_path__ + "static/media/Panel_5_Stage1.f23b6c29.svg";